import { Grid, Typography } from '@mui/material'

export interface GridListItemProps {
  label: string
  transform?: (value?: any) => string
  value?: any
  RenderValue?: any
  key: string
}

export const GridListItem = (props: GridListItemProps) => {
  const {
    label,
    transform = (value: unknown): string => value as string,
    value,
    RenderValue
  } = props

  let normalizedValue = '-'

  if (value !== null && value !== undefined && value !== '')
    normalizedValue = transform(value)

  return (
    <>
      <Grid item xs={5}>
        <Typography variant="body2">{label}</Typography>
      </Grid>
      <Grid item xs={7}>
        {RenderValue || (
          <Typography variant="body1" style={{ fontSize: 14, fontWeight: 500 }}>
            {normalizedValue}
          </Typography>
        )}
      </Grid>
    </>
  )
}
